module.exports = __webpack_public_path__ + "assets/25856b4f6cc358de8a9000cafe4299c2.ttf";